module.exports = __webpack_public_path__ + "img/swipe-file.cd088425.png";